import { render, staticRenderFns } from "./RecoveryView.vue?vue&type=template&id=1318fe89&scoped=true&"
import script from "./RecoveryView.vue?vue&type=script&lang=js&"
export * from "./RecoveryView.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryView.vue?vue&type=style&index=0&id=1318fe89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318fe89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
